import React from 'react';
import { ArrowDown, Lock } from 'lucide-react';
import { Button } from '../Button';
import { SiteHeader } from './SiteHeader';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-tint" data-id="element-27" data-mp="bx0itdoqvxxk">
      {/* One continuous background shared by the header and the hero */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-tint" data-id="element-28" data-mp="21gpmz1kfdci" />
      <img src="https://cdn.magicpatterns.com/uploads/ondqLKtMvXu7hpZjz12hEG/651c864205e41b56aae10585_Group.png" alt="" aria-hidden="true" className="pointer-events-none absolute -top-32 right-0 h-[480px] w-[900px] max-w-none select-none object-cover opacity-75 sm:-top-40 sm:h-[620px] sm:w-[1200px]" data-id="element-29" data-mp="3t807uz9qe5ku" />
      {/* Soft dissolve into the white section below */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-b from-transparent via-white/70 to-white" data-id="element-30" data-mp="3affl7zkmkwph" />

      <div className="relative" data-id="element-31" data-mp="2naap3gu5nir6">
        <SiteHeader data-id="element-32" data-mp="2na2clq1y2fgi" />

        <div className="mx-auto flex w-full max-w-[1280px] flex-col justify-center px-6 pb-24 pt-14 sm:px-10 sm:pt-16 lg:min-h-[480px] lg:pb-32" data-id="element-33" data-mp="2n8r7nmwrj1nt">
          <div className="max-w-3xl" data-id="element-34" data-mp="2dd695yqwkjit">
            <h1 className="font-heading text-[40px] font-bold leading-[1.05] tracking-tight text-ink sm:text-[52px] lg:text-[64px]" data-id="element-35" data-mp="2de7l05fqta1l">
              BOSS Webinar Registration Centre
            </h1>
            <p className="mt-7 max-w-[650px] text-lg leading-[1.7] text-body sm:text-xl" data-id="element-36" data-mp="361v3nexgdqll">
              Register for upcoming BOSS training webinars. Choose the sessions
              that best fit your schedule.
            </p>

            <div className="mt-8 flex w-full max-w-[650px] items-start gap-3 rounded-full border border-brand/15 bg-white/70 px-5 py-4 sm:w-fit sm:items-center" data-id="element-37" data-mp="2w5if0vgrm2xp">
              <Lock className="mt-0.5 h-5 w-5 shrink-0 text-brand sm:mt-0" aria-hidden="true" data-id="element-38" data-mp="1kmflskrq8ak6" />
              <p className="text-[15px] leading-relaxed text-body" data-id="element-39" data-mp="3s9r241le1vf2">
                This page is private and intended for invited BOSS users only.
              </p>
            </div>

            <div className="mt-10" data-id="element-40" data-mp="3ncquvncsymmd">
              <Button asChild size="lg" className="btn-gradient h-[52px] w-full rounded-full px-10 text-base font-medium text-white shadow-card transition-shadow hover:shadow-card-hover sm:w-auto" data-id="element-41" data-mp="3ije71ffy6juo">
                <a href="#webinars" className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap" data-id="element-42" data-mp="38jf0fo3393kg">
                  View Upcoming Webinars
                  <ArrowDown className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-43" data-mp="2ulyv6fwj3fua" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}